export default __webpack_public_path__ + "static/media/stadistics.dd81ac53.svg";